import { Component, OnInit, inject } from "@angular/core";
import { Router } from "@angular/router";
import { faBan } from "@fortawesome/pro-light-svg-icons";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import Keycloak from "keycloak-js";

@Component({
  selector: "app-no-access",
  templateUrl: "./no-access.component.html",
  styleUrls: ["./no-access.component.css"],
  imports: [FaIconComponent],
})
export class NoAccessComponent implements OnInit {
  private readonly keycloak = inject(Keycloak);
  private readonly router = inject(Router);

  banIcon = faBan;

  constructor() {}

  ngOnInit() {}

  hasHomeAccess(): boolean {
    const parsed = this.keycloak.tokenParsed as any;
    return parsed.realm_access?.roles?.includes("home:full");
  }

  redirectToHome() {
    this.router.navigate(["/core/home"]);
  }
}
